import React from "react";
import { Box } from "@mui/material";

function AdminHome() {
  return (
    <Box
      sx={{
        backgroundColor: "primary",
        p: 4,
      }}
    ></Box>
  );
}

export default AdminHome;
